// Decca monogram avatar. Size variants + styling live in decca.css.
const DeccaAvatar = ({ size = "md", dot = false }) => (
  <span className={`dz-avatar dz-avatar-${size}`}>
    <span className="dz-avatar-mono">D</span>
    {dot && <span className="dz-avatar-dot" />}
  </span>
);

export default DeccaAvatar;
